<template>
  <div>
     <pt-sub-title title="用户钱包"></pt-sub-title>
     <user-wallet-message :walletDetail="walletDetail" v-loading="walletLoading" :isEditUserWallet="isEditUserWallet"
     @change="changeAccount"></user-wallet-message>
     <div class="button-div">
        <el-button v-if="!isEditUserWallet" type="primary" @click="editMessage">信息修改</el-button>
        <el-button v-else  type="primary" @click="submit" :loading="submitLoading">保存修改</el-button>
      </div>
     <pt-sub-title title="交易记录"></pt-sub-title>
     <trading-record @getTableData="getTableData" ref="table" :tableLabels="recordTableLabels" :totalNumber="totalNumber"
     :pageSize="pageSize" :tableData="tableData">
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.accountDetail&&scope.row.accountDetail.businessType==='WITHDRAWALS'" type="text" @click="recordDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
     </trading-record>
  </div>
</template>
<script>
import userWalletMessage from './user-wallet-message'
import tradingRecord from './trading-record'
import { recordTableLabels } from './customer-detail-option'
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    userWalletMessage,
    tradingRecord
  },
  data () {
    return {
      walletDetail: {},
      walletLoading: false,
      recordTableLabels: recordTableLabels,
      isEditUserWallet: false,
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      updataWallet: {},
      submitLoading: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    changeAccount (val) {
      this.updataWallet = {
        bankAccount: val.bankAccount,
        wxWithdrawalsAccount: val.wxWithdrawalsAccount
      }
    },
    walletAccountDetail () {
      this.walletLoading = true
      this.$store.dispatch('walletAccountDetail', this.id).then(res => {
        this.walletLoading = false
        this.walletDetail = res
      }).catch(err => {
        this.walletLoading = false
        this.$message.error(err || '获取用户钱包信息失败')
      })
    },
    editMessage () {
      this.isEditUserWallet = true
    },
    submit () {
      this.submitLoading = true
      this.$store.dispatch('walletAccountEdit', this.updataWallet).then(res => {
        this.isEditUserWallet = false
        this.submitLoading = false
        this.$message.success('编辑钱包成功')
      }).catch(err => {
        this.isEditUserWallet = false
        this.submitLoading = false
        this.$message.error(err || '编辑钱包失败')
      })
    },
    getTableData (page, next) {
      let data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        },
        userId: this.id
      }
      this.$store.dispatch('walletAccountRecord', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取交易记录失败')
      })
    },
    recordDetail (row) {
      if (row.accountDetail.businessType === 'WITHDRAWALS') {
        this.$router.push('/withdraw-audit/withdraw-detail/' + row.withdrawalsLog.id)
      } else {
        this.$router.push('/reward-grant-audit/award-audit-detail/' + row.withdrawalsLog.id)
      }
    }
  },
  created () {
    this.walletAccountDetail()
  }
}
</script>
<style module lang="less">

</style>
